import { useEffect, useState } from "react"
import { Tabs, Tab } from "react-bootstrap"
import VideoListingContentComponent from "./VideoListingContentComponent"
import useLogin from "../../../../custom-hooks/useLogin"
import { SessionKeys, getStepIndex } from "../../../../utils/AppUtils"
import _ from "lodash"
import { useDispatch, useSelector } from "react-redux"
import { setJoyRideReq } from "../../../../redux/assignCourse/actions"
import VideoListingPopular from "./VideoListingPopular"
import VideoListingMy from "./VideoListingMy"
import VideoListingNew from "./VideoListingNew"

const VideoListingSectionComponent = () => {

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const c = params.get("c");
    let providerId = "";
    let allPartners = "";
    let providerName = "";
    let tab = params.get("tab");
    if (c) {
        let decodedString = atob(c);
        let paramsReq = JSON.parse(decodedString);
        providerId = paramsReq.provider_id;
        allPartners = paramsReq?.allPartners;
        providerName = paramsReq?.provider_name;
       
    }
    //   const providerId = paramsReq.provider_id;
    // const providerId = params.get("provider_id");

    const { isLoggedIn } = useLogin();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.user.role);
    const authBroker = useSelector((state) => state.auth.authBroker);
    const isPremiumUser = useSelector((state) => state.user.isPremiumUser);


    const [key, setKey] = useState(tab === "2" ? 'popular':'all')

    useEffect(() => {
        
      if(tab === "2") {
         setKey("popular");
      }
    }, [tab]);

    useEffect(() => {
        if (
            sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" &&
            !_.isEmpty(authBroker)
        ) {
            const isGuest = authBroker.payload.user.role.includes("guest");
            const stepIndex = getStepIndex(
                "#idVideosMenu",
                userRole,
                isPremiumUser,
                isGuest
            );
            dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }));
        }
    }, [])

    const renderVideoListing = () => {
        if(key==="all"){
        return (
            <VideoListingContentComponent
                tabKey={key}
                showMostPopular={false}
                showMostLiked={false}
                showMyVideos={false}
                showAllVideos={true}
            />
            )
        }else {
            return ""
        }
    }

    const renderPopularVideoListing = () => {
        if(key==="popular"){
          return  <VideoListingPopular />
        }else {
            return ""
        }
    }

    const renderMyVideoListing = () => {
        if(key==="my-videos"){
            return <VideoListingMy />
        }else {
            return ""
        }
    }

    const renderNewVideoListing = () => {
        if(key === "new-videos"){
            return <VideoListingNew />
        }else {
            return ""
        }
}


    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {

        };
    }, []);


    const renderTitle = () => {
        return (
        <div dangerouslySetInnerHTML={{__html: allPartners ? `Videos from ${authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
            authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase():
            "Learning Partners"}`: providerName ? `Videos from ${providerName}` : "All Videos"}}></div>
        )
    }

    return (
        <>
            <div className="contsection video-listing-content">
                <Tabs
                    underline
                    activeKey={key}
                    onSelect={(k) => {
                        const url = new URL(window.location.href);
                        url.search = "";
                        window.history.pushState({}, "", url.href);

                        if(document.getElementById("idFooter")!==null){
                            document.getElementById("idFooter").style.display = 'none'
                        }
                        if(allPartners || providerName) {

                        }
                        else {setKey(""); }
                        setTimeout(() => {
                            setKey(k)   
                            if(document.getElementById("idFooter")!==null){
                                document.getElementById("idFooter").style.display = 'block'
                            } 
                        }, 200);
                        
                    }}
                >
                    <Tab eventKey={'all'} title={renderTitle()}>
                        {renderVideoListing()}
                    </Tab>
                    { !providerId && !allPartners && <Tab eventKey={'popular'} title="Most popular Videos">
                        {renderPopularVideoListing()}
                    </Tab> }
                    {(isLoggedIn && !providerId) && !allPartners &&
                        <Tab eventKey={'new-videos'} title="New Videos">
                            {renderNewVideoListing()}
                        </Tab>}
                    {(isLoggedIn && !providerId) && !allPartners &&
                        <Tab eventKey={'my-videos'} title="My Videos">
                            {renderMyVideoListing()}
                        </Tab>}
                </Tabs>
            </div>
        </>
    )
}

export default VideoListingSectionComponent